module.exports = __webpack_public_path__ + "static/media/github-web.cee6deaf.svg";